export default __webpack_public_path__ + "static/media/monzo.1e406cce.svg";